import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LosService } from "../../_LOS/services/los.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as XLSX from "xlsx";
declare var $: any;

@Component({
    selector: "app-mst-branches",
    templateUrl: "./mst-branches.component.html",
    styleUrls: ["./mst-branches.component.scss"],
    standalone: false
})
export class MstBranchesComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  RequestModel: RequestModel = new RequestModel();
  GetBranchDetailRequestModel: RequestModel = new RequestModel();
  GetEmployeeDropdownRequestModel: RequestModel = new RequestModel();
  SaveBranchRequestModel: RequestModel = new RequestModel();
  DeleteBranchRequestModel: RequestModel = new RequestModel();
  GetDistrictRequestModel: RequestModel = new RequestModel();
  GetFilterDistrictRequestModel: RequestModel = new RequestModel();
  GetTehsilRequestModel: RequestModel = new RequestModel();

  dataSource: any;
  loading: boolean = false;
  displayedColumns: string[] = [
    "BranchId",
    "Branch_Name",
    "Branch_Code",
    "Branch_Type",
    "District_Name",
    "Tehsil_Name",
    "Branch_PhoneNo",
    "Branch_Head",
    "Branch_OpeningDate",
    "EditAction",
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  FilterZoneId: any = "";
  FilterDistrictId: any = "";
  FilterDistrictList: any = [];
  ZoneListDropdown: any = [];
  BranchesList: any = [];
  StateList: any = [];
  DistrictList: any = [];
  TehsilList: any = [];
  RegionList: any = [];
  ClusterList: any = [];
  allRegionsCache: any[] = [];
  allClustersCache: any[] = [];
  GetBranchDetail: any = {};
  GetEmployeeDropdown: any = [];
  BranchID: any = 0;
  BranchName: any = "";
  BranchType: any = "";
  SelectZoneId: any = "";
  StateId: any = "";
  RegionId: any = "";
  ClusterId: any = "";
  DistrictId: any = "";
  TehsilId: any = "";
  Address: any = "";
  LandMark: any = "";
  Pincode: any = "";
  PhoneNo: any = "";
  BranchSetupDate: any = new Date();
  BranchHead: any = "";
  Remarks: any = "";
  BranchCode: any = "";
  GSTNo: any = "";
  EmailId: any = "";

  // google map
  lat = undefined;
  lng = undefined;
  animation: string = "DROP";
  // delete branch reason
  DeletionReason: string = "";
  dialogreturn: any;

  today: Date = new Date();
  BranchModel: any = {};
  UploadImageBase64: any = "";
  UploadImageBase64QR: any = "";

  FilterStateId: any = "";
  stateDropdown: any[] = [];
  FilterInputSearch: any;
  JsonData: any[] = [];

  imagePreview: string | ArrayBuffer | null = null;
  errorMessage: string | null = null;

  constructor(
    private dataSharingService: DataSharingService,
    private dialog: DialogService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private cdr: ChangeDetectorRef
  ) {
    this._MasterService = MasterService;
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Branch List");
    this.cdr.detectChanges();
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
    this._MasterService.GetZoneListDropdown().subscribe((result) => {
      this.ZoneListDropdown = JSON.parse(JSON.stringify(result));
    });
    this.GetFilterDistrictRequestModel.StateId = 29;
    // this._MasterService
    //   .GetDistricts(this.GetFilterDistrictRequestModel)
    //   .subscribe((result) => {
    //     this.FilterDistrictList = JSON.parse(JSON.stringify(result));
    //   });
    this.getBranchesList();

    this.BranchModel = {
      Branch_Is_Rented: "",
      Branch_ContractFrom: "",
      Branch_ContractTo: "",
      Branch_Landlord_Name: "",
      Branch_Landlord_PanNo: "",
      Branch_Monthly_Rent: "",
      Branch_Rent_Due_Date: "",
      Branch_PaymentInFavourOf: "",
      Branch_AgrrementDoc: "",
      BranchQRCode: "",
    };

    this.GetStateDropdown();

    // Saare regions aur clusters ek baar load karke cache kar lo
    // Taaki baar-baar API call na karni pade aur async timing issues na aaye
    this.LmsService.GetRegionMaster().subscribe((result: any) => {
      this.allRegionsCache = JSON.parse(JSON.stringify(result));
    });
    this.LmsService.GetClusterMaster().subscribe((result: any) => {
      this.allClustersCache = JSON.parse(JSON.stringify(result));
    });
  }

  // exportExcel() {
  //   if (this.dataSource) {
  //     this.JsonData = this.dataSource.filteredData || this.dataSource.data;
  //     this.cdr.detectChanges();
  //     setTimeout(() => {
  //       let table = document.getElementById("branch-details");
  //       if (table) {
  //         const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
  //         const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //         XLSX.utils.book_append_sheet(wb, ws, "Branches");
  //         XLSX.writeFile(wb, "BranchList.xlsx");
  //       }
  //     }, 100);
  //   }
  // }
  exportExcel() {
  if (this.dataSource) {
    this.JsonData = this.dataSource.filteredData || this.dataSource.data;

    // Date ko string force karo JSON mein hi
    const formattedData = this.JsonData.map((x: any, i: number) => ({
      '#': i + 1,
      'Branch Name': x.Branch_Name,
      'Branch Code': x.Branch_Code,
      'Branch Type': x.Branch_Type,
      'District Name': x.District_Name,
      'Tehsil Name': x.Tehsil_Name,
      'Branch Phone No': x.Branch_PhoneNo,
      'Branch Head': x.Branch_Head,
      'Open Date': x.Branch_OpeningDate
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Branches");
    XLSX.writeFile(wb, "BranchList.xlsx");
  }
}
  getBranchesList() {
    this.showSpinner = true;
    this.RequestModel.ZoneId =
      this.FilterZoneId == "" ? 0 : parseInt(this.FilterZoneId);
    this.RequestModel.DistrictId =
      this.FilterDistrictId == "" ? 0 : parseInt(this.FilterDistrictId);
    this._MasterService.GetBranches(this.RequestModel).subscribe((result) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
      this.dataSource = new MatTableDataSource(this.BranchesList);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.showSpinner = false;
    });
  }

  applyFilter(filterValue: string) {
    console.log("filterValue", filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // start google map
  mapClicked($event: any) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
  }

  markerOver() {
    this.animation = "BOUNCE";
  }

  markerOut() {
    this.animation = "";
  }
  //end google map
  clearForm() {
    this.BranchName = "";
    this.BranchCode = "";
    this.BranchType = "";
    this.SelectZoneId = "";
    this.StateId = "";
    this.RegionId = "";
    this.ClusterId = "";
    this.DistrictId = "";
    this.TehsilId = "";
    this.Address = "";
    this.LandMark = "";
    this.Pincode = "";
    this.PhoneNo = "";
    this.BranchSetupDate = null;
    this.BranchHead = "";
    this.Remarks = "";
    this.lat = undefined;
    this.lng = undefined;
    this.EmailId = "";
    this.GSTNo = "";
    this.DistrictList = [];
    this.TehsilList = [];
    this.RegionList = [];
    this.ClusterList = [];
  }

  OnOpenBranchModal(selectBranchId) {
    this.clearForm();
    this._MasterService.GetState().subscribe((result) => {
      this.StateList = JSON.parse(JSON.stringify(result));
    });
    this.GetEmployeeDropdownRequestModel.BranchId = 0;
    this.GetEmployeeDropdownRequestModel.ProcessId = 0;
    this._MasterService
      .GetEmployeeDropdown(this.GetEmployeeDropdownRequestModel)
      .subscribe((result) => {
        this.GetEmployeeDropdown = JSON.parse(JSON.stringify(result));
      });

    this.BranchModel.Branch_Is_Rented = "";

    this.BranchID = selectBranchId;
    if (this.BranchID != 0) {
      this.GetBranchDetailRequestModel.BranchId = this.BranchID;
      this._MasterService
        .GetBrancheDetails(this.GetBranchDetailRequestModel)
        .subscribe((result) => {
          this.GetBranchDetail = result[0];
          console.log("this.GetBranchDetail", result);
          if (result.length > 0) {
            this.BranchName = this.GetBranchDetail.Branch_Name;
            this.BranchCode = this.GetBranchDetail.Branch_Code;
            this.BranchType = this.GetBranchDetail.Branch_Type;
            this.SelectZoneId = this.GetBranchDetail.Branch_ZoneId;
            this.StateId = this.GetBranchDetail.Branch_StateId;
            this.onChangeState();
            this.DistrictId = this.GetBranchDetail.Branch_DistrictId;
            this.onChangeDistrict();
            this.TehsilId = this.GetBranchDetail.Branch_TehsilId;
            this.RegionId = this.GetBranchDetail.Branch_RegionId ? this.GetBranchDetail.Branch_RegionId.toString() : "";
            
            if (this.RegionId && this.allRegionsCache.length > 0) {
               const isValid = this.RegionList.some((r: any) => r.RegionId.toString() === this.RegionId);
               if (!isValid) this.RegionId = "";
            }

            if (this.RegionId) {
              this.onChangeRegion();
              this.ClusterId = this.GetBranchDetail.Branch_ClusterId ? this.GetBranchDetail.Branch_ClusterId.toString() : "";
              
              if (this.ClusterId && this.allClustersCache.length > 0) {
                 const isValid = this.ClusterList.some((c: any) => c.ClusterId.toString() === this.ClusterId);
                 if (!isValid) this.ClusterId = "";
              }
            } else {
              this.ClusterId = "";
            }
            this.Address = this.GetBranchDetail.Branch_Address;
            this.LandMark = this.GetBranchDetail.Branch_LandMark;
            this.Pincode = this.GetBranchDetail.Branch_PinCode;
            this.PhoneNo = this.GetBranchDetail.Branch_PhoneNo;
            this.BranchSetupDate = new Date(
              this.GetBranchDetail.Branch_SetupDate
            );
            this.BranchHead = this.GetBranchDetail.Branch_HeadId;
            this.Remarks = this.GetBranchDetail.Branch_Remark;
            this.lat = parseFloat(
              String(this.GetBranchDetail.Branch_LatLong).split(",")[0]
            );
            this.lng = parseFloat(
              String(this.GetBranchDetail.Branch_LatLong).split(",")[1]
            );
            this.GSTNo = this.GetBranchDetail.Branch_GSTNo;
            this.EmailId = this.GetBranchDetail.Branch_EmailId;
            this.BranchModel.Branch_Is_Rented =
              this.GetBranchDetail.Branch_Is_Rented;
            this.BranchModel.Branch_ContractFrom = new Date(
              this.GetBranchDetail.Branch_ContractFrom
            );
            this.BranchModel.Branch_ContractTo = new Date(
              this.GetBranchDetail.Branch_ContractTo
            );
            this.BranchModel.Branch_Landlord_Name =
              this.GetBranchDetail.Branch_Landlord_Name;
            this.BranchModel.Branch_Landlord_PanNo =
              this.GetBranchDetail.Branch_Landlord_PanNo;
            this.BranchModel.Branch_Monthly_Rent =
              this.GetBranchDetail.Branch_Monthly_Rent;
            this.BranchModel.Branch_Rent_Due_Date = new Date(
              this.GetBranchDetail.Branch_Rent_Due_Date
            );
            this.BranchModel.Branch_AgrrementDoc =
              this.GetBranchDetail.Branch_AgrrementDoc;
            this.BranchModel.Branch_PaymentInFavourOf =
              this.GetBranchDetail.Branch_PaymentInFavourOf;
            this.UploadImageBase64 =
              this.GetBranchDetail.Branch_AgrrementDoc != ""
                ? constantUrl.OthersDocUrl +
                  this.GetBranchDetail.Branch_AgrrementDoc
                : "";

            this.BranchModel.BranchQRCode = this.GetBranchDetail.BranchQRCode;

            this.UploadImageBase64QR =
              this.GetBranchDetail.BranchQRCode != ""
                ? constantUrl.OthersDocUrl + this.GetBranchDetail.BranchQRCode
                : "";
          }
        });
    }

    $("#AddNewBranchModal").modal("show");
    $("#AddNewBranchModal").css("z-index", "1050");
  }
  openGoogleMaps(): void {
    if (this.lat && this.lng) {
      const url = `https://www.google.com/maps?q=${this.lat},${this.lng}`;
      window.open(url, "_blank");
    } else {
      alert("Latitude or Longitude not available");
    }
  }

  // Jab State select karega:
  // Cache se StateId match karne wale regions filter hote hain
  onChangeState() {
    this.DistrictList = [];
    this.TehsilList = [];
    this.ClusterList = [];
    this.RegionList = [];
    this.RegionId = "";
    this.ClusterId = "";
    this.DistrictId = "";
    this.TehsilId = "";

    // Districts load karo StateId ke saath
    this.GetDistrictRequestModel.StateId = parseInt(this.StateId);
    this._MasterService
      .GetDistricts(this.GetDistrictRequestModel)
      .subscribe((result) => {
        this.DistrictList = JSON.parse(JSON.stringify(result));
      });

    const stateIdNum = parseInt(this.StateId);

    // Agar cache available hai to wahan se filter karo, otherwise API call
    if (this.allRegionsCache.length > 0) {
      this.RegionList = this.allRegionsCache.filter(
        (r: any) => parseInt(r.StateId) === stateIdNum
      );
    } else {
      this.LmsService.GetRegionMaster().subscribe((result: any) => {
        const allRegions = JSON.parse(JSON.stringify(result));
        this.allRegionsCache = allRegions;
        this.RegionList = allRegions.filter(
          (r: any) => parseInt(r.StateId) === stateIdNum
        );
        if (this.RegionId) {
           const isValid = this.RegionList.some((r: any) => r.RegionId.toString() === this.RegionId.toString());
           if (!isValid) {
              this.RegionId = "";
              this.ClusterId = "";
           }
        }
      });
    }
  }

  onChangeDistrict() {
    this.GetTehsilRequestModel.StateId = parseInt(this.StateId);
    this.GetTehsilRequestModel.DistrictId = parseInt(this.DistrictId);
    this._MasterService
      .GetTahsil(this.GetTehsilRequestModel)
      .subscribe((result) => {
        this.TehsilList = JSON.parse(JSON.stringify(result));
      });
  }

  // Jab Region select karega:
  // Cache se RegionId match karne wale clusters filter hote hain
  onChangeRegion() {
    this.ClusterList = [];
    this.ClusterId = "";
    const regionIdNum = parseInt(this.RegionId);

    if (this.allClustersCache.length > 0) {
      this.ClusterList = this.allClustersCache.filter(
        (c: any) => parseInt(c.RegionId) === regionIdNum
      );
    } else {
      this.LmsService.GetClusterMaster().subscribe((result: any) => {
        const allClusters = JSON.parse(JSON.stringify(result));
        this.allClustersCache = allClusters;
        this.ClusterList = allClusters.filter(
          (c: any) => parseInt(c.RegionId) === regionIdNum
        );
        if (this.ClusterId) {
           const isValid = this.ClusterList.some((c: any) => c.ClusterId.toString() === this.ClusterId.toString());
           if (!isValid) this.ClusterId = "";
        }
      });
    }
  }

  OnClose() {
    this.BranchID = 0;
    this.BranchName = "";
    this.BranchCode = "";
    this.BranchType = "";
    this.SelectZoneId = "";
    this.StateId = "";
    this.RegionId = "";
    this.ClusterId = "";
    this.DistrictId = "";
    this.TehsilId = "";
    this.Address = "";
    this.LandMark = "";
    this.Pincode = "";
    this.PhoneNo = "";
    this.BranchSetupDate = "";
    this.BranchHead = "";
    this.Remarks = "";
    this.DistrictList = [];
    this.TehsilList = [];
    this.RegionList = [];
    this.ClusterList = [];
    this.lat = undefined;
    this.lng = undefined;
    $("#AddNewBranchModal").modal("hide");
  }

  fileChangeListenerForQRCode(data: any, files: any) {
    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    data.BranchQRCode = _pre + "_" + sanitizedFileName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      data.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }
  removeFileQRCode(data: any, input: any) {
    input.value = "";
    data.BranchQRCode = "";
    delete data.DocData;
  }

  onSaveBranchData() {
    let saveBranchJSON = {
      Branch: {
        BranchId: this.BranchID,
        Branch_ZoneId: parseInt(this.SelectZoneId),
        Branch_Name: this.BranchName,
        Branch_Code: this.BranchCode,
        Branch_DistrictId: parseInt(this.DistrictId),
        Branch_TehsilId: parseInt(this.TehsilId),
        Branch_Address: this.Address,
        Branch_LandMark: this.LandMark,
        Branch_PhoneNo: this.PhoneNo,
        Branch_PinCode: this.Pincode,
        Branch_Type: this.BranchType,
        Branch_HeadId: this.BranchHead,
        Branch_SetupDate: new Date(this.BranchSetupDate).toLocaleDateString(
          "fr-CA"
        ),
        Branch_LatLong: `${this.lat},${this.lng}`,
        Branch_CreateBy: this.data.userId,
        Branch_ModifyBy: this.data.userId,
        Branch_Remark: this.Remarks,
        Branch_Is_Rented: this.BranchModel.Branch_Is_Rented,
        Branch_ContractFrom: this.BranchModel.Branch_ContractFrom,
        Branch_ContractTo: this.BranchModel.Branch_ContractTo,
        Branch_Landlord_Name: this.BranchModel.Branch_Landlord_Name,
        Branch_Landlord_PanNo: this.BranchModel.Branch_Landlord_PanNo,
        Branch_Monthly_Rent: this.BranchModel.Branch_Monthly_Rent,
        Branch_Rent_Due_Date: this.BranchModel.Branch_Rent_Due_Date,
        Branch_AgrrementDoc: this.BranchModel.Branch_AgrrementDoc,
        Branch_PaymentInFavourOf: this.BranchModel.Branch_PaymentInFavourOf,
        Branch_RegionId: parseInt(this.RegionId),
        Branch_ClusterId: parseInt(this.ClusterId),
        Branch_GSTNo: this.GSTNo,
        Branch_EmailId: this.EmailId,
        BranchQRCode: this.BranchModel.BranchQRCode,
      },
    };

    //Upload Document
    this.uploadBranchAgreementDocs(this.BranchModel);
    this.uploadBranchQRCode(this.BranchModel);
    this.SaveBranchRequestModel.JSON = JSON.stringify(saveBranchJSON);
    this._MasterService
      .SaveBranchDetails(this.SaveBranchRequestModel)
      .subscribe((response) => {
        if (response[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.getBranchesList();
          this.OnClose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  onOpenDeleteModal(selectedBranchId) {
    this.dialogreturn = this.dialog.openConfirmDialog(
      "Are you sure you want to delete?"
    );
    this.dialogreturn.afterClosed().subscribe((dialogResult) => {
      if (dialogResult == true) {
        this.BranchID = selectedBranchId;
        $("#DeleteBranchModal").modal("show");
        $("#DeleteBranchModal").css("z-index", "1050");
      }
    });
  }

  onDeleteBranch() {
    this.DeleteBranchRequestModel.BranchId = this.BranchID;
    this.DeleteBranchRequestModel.LoginUserId = this.data.userId;
    this.DeleteBranchRequestModel.DeletionReason = this.DeletionReason;
    this._MasterService
      .DeleteBranchDetails(this.DeleteBranchRequestModel)
      .subscribe((response) => {
        if (response[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.getBranchesList();
          this.OnCloseDeleteModal();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  OnCloseDeleteModal() {
    this.BranchID = 0;
    this.DeletionReason = "";
    $("#DeleteBranchModal").modal("hide");
  }

  fileChangeListener(data: any, files: any) {
    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    data.Branch_AgrrementDoc = _pre + "_" + sanitizedFileName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      data.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }
  removeFile(data: any, input: any) {
    input.value = "";
    data.Branch_AgrrementDoc = "";
    delete data.DocData;
  }

  uploadBranchAgreementDocs(data: any) {
    if (data.DocData) {
      this._MasterService
        .SaveOtherDocPath({
          DocName: data.Branch_AgrrementDoc,
          DocData: data.DocData,
        })
        .subscribe((res: any) => {
          console.log("res", res);
        });
    }
  }

  uploadBranchQRCode(data: any) {
    if (data.DocData) {
      this._MasterService
        .SaveOtherDocPath({
          DocName: data.BranchQRCode,
          DocData: data.DocData,
        })
        .subscribe((res: any) => {
          console.log("res", res);
        });
    }
  }

  onChangeBranchType() {
    if (this.BranchModel.Branch_Is_Rented == 0) {
      this.BranchModel = {
        Branch_Is_Rented: 0,
        Branch_ContractFrom: "",
        Branch_ContractTo: "",
        Branch_Landlord_Name: "",
        Branch_Landlord_PanNo: "",
        Branch_Monthly_Rent: "",
        Branch_Rent_Due_Date: "",
        Branch_PaymentInFavourOf: "",
        Branch_AgrrementDoc: "",
      };
    } else {
      this.BranchModel = {
        Branch_Is_Rented: 1,
        Branch_ContractFrom: "",
        Branch_ContractTo: "",
        Branch_Landlord_Name: "",
        Branch_Landlord_PanNo: "",
        Branch_Monthly_Rent: "",
        Branch_Rent_Due_Date: "",
        Branch_PaymentInFavourOf: "",
        Branch_AgrrementDoc: "",
      };
    }
  }

  GetStateDropdown() {
    this.losService.GetStateDropdown({}).subscribe((res: any) => {
      this.stateDropdown = res;
    });
  }

  GetDistrickDropdown() {
    this.losService
      .GetDistrickDropdown({ StateID: this.FilterStateId })
      .subscribe((res: any) => {
        this.FilterDistrictList = res;
      });
  }
}
